var React = require('react');

function DownloadArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"clip-path-144"},React.createElement("path",{"id":"Mask","d":"M.75,22.01a.75.75,0,0,1-.1-1.493l.1-.007h20.5a.75.75,0,0,1,.1,1.493l-.1.007ZM10.88,16.6l-.092-.014-.1-.029-.105-.049-.083-.053-.046-.037L3.934,9.9A.75.75,0,0,1,4.91,8.767l.084.073,5.2,5.2V.75a.75.75,0,0,1,1.493-.1l.007.1V14.04l5.2-5.2a.75.75,0,0,1,1.133.977l-.073.085-6.48,6.48a.81.81,0,0,1-.1.085l-.1.06-.114.044-.111.024-.1.006Z","transform":"translate(4 4)"}))),React.createElement("g",{"id":"Mask_Group_144","data-name":"Mask Group 144","transform":"translate(-4 -4)","clipPath":"url(#clip-path-144)","key":1},React.createElement("g",{"id":"Colour"},React.createElement("rect",{"id":"Rectangle","width":"30","height":"30"})))]);
}

DownloadArrow.defaultProps = {"width":"22","height":"22.01","viewBox":"0 0 22 22.01"};

module.exports = DownloadArrow;

DownloadArrow.default = DownloadArrow;
